<template lang="pug">
  v-container.pa-5(fluid grid-list-md fill-height)
    d-add(ref="dialogAdd" :customer-id="customerId" :ad-group-id="adGroupId" @complele="doLoadKeywords(true)")
    d-copy(ref="dialogCopy" :customer-id="customerId" :keyword-selecteds="itemSelecteds")

    v-layout(column)
      v-flex.mb-3
        v-layout(row)
          v-flex(xs4 d-flex align-center)
            v-icon.pr-2(size="40") autorenew
            v-flex
              .headline Keywords
              .overline {{ adGroupId }}
          v-flex(d-flex justify-end align-center)
            v-btn.mr-2(@click="doLoadKeywords(true)") Refersh
            v-btn.mr-2(:disabled="!itemSelecteds.length" @click="$refs.dialogCopy.show()") Copy
            v-btn(@click="$refs.dialogAdd.show()") Add Keyword

      v-flex(fill-height)
        v-card
          v-data-table(
            :headers="headers"
            :items="items"
            :loading="loading"
            :items-per-page="15"
            item-key="adGroupCriterion.resourceName"
            v-model="itemSelecteds"
            show-select
          )
</template>

<script>
import { mapActions } from 'vuex'
import DAdd from './dialogs/AddAdGroupKeyword'
import DCopy from './dialogs/CopyAdGroupKeyword'

export default {
  components: {
    DAdd,
    DCopy
  },
  data () {
    return {
      customerId: null,
      campaignId: null,
      adGroupId: null,
      loading: false,
      items: [],
      itemSelecteds: [],
      headers: [
        { text: 'Keyword', value: 'adGroupCriterion.keyword.text' },
        { text: 'Status', value: 'adGroupCriterion.status' },
        { text: 'Clicks', value: 'metrics.clicks' },
        { text: 'Impr.', value: 'metrics.impressions' },
        { text: 'CTR', value: 'metrics.ctr' },
        { text: 'Avg. CPC', value: 'metrics.averageCpc' },
        { text: 'Cost', value: 'metrics.costMicros' }
      ]
    }
  },
  async mounted () {
    this.customerId = this.$route.params.customer
    this.campaignId = this.$route.params.campaign
    this.adGroupId = this.$route.params.adgroup
    this.doLoadKeywords()
  },
  methods: {
    ...mapActions({
      loadAdGroupKeywords: 'ads/loadAdGroupKeywords'
    }),
    async doLoadKeywords (reload = false) {
      if (this.customerId && this.adGroupId) {
        const params = {
          customerId: this.customerId,
          campaignId: this.campaignId,
          adGroupId: this.adGroupId,
          reload: reload
        }
        this.loading = true
        this.items = await this.loadAdGroupKeywords(params)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped></style>
